/**The type of form (used by form-service) */
export enum FormType {
    Form = 'form',
    Setup = 'setup',
    Registration = 'registration',
    FormView = 'formview',
    SubForm = 'subform',
    None = ''
}
